/*------------------------------------*\
    inputmask
\*------------------------------------*/

module.exports = function(){

    $(function(){
        $('.js-mask-age').inputmask("9[9]", { "placeholder": "_" }, { numericInput: true });
        $('.js-mask-height').inputmask("9\'9\[9\]\"", { "placeholder": "_" }, { numericInput: true });
        $('.js-mask-weight').inputmask("99[9]", { "placeholder": "_" }, { numericInput: true });
        $('.js-mask-waist-size').inputmask("99", { "placeholder": "_" }, { numericInput: true });
        $('.js-mask-pant-length').inputmask("99 \× 99", { "placeholder": "_" }, { numericInput: true });
        $('.js-mask-shoe-size').inputmask("9[9]", { "placeholder": "_" }, { numericInput: true });
        $('.js-mask-neck-size').inputmask("9[9][\.9]", { "placeholder": "_" }, { numericInput: true });
        $('.js-mask-sleeve-length').inputmask("99", { "placeholder": "_" }, { numericInput: true });
        $('.js-mask-jacket-size').inputmask("99", { "placeholder": "_" }, { numericInput: true });


        $("[js-mask-date]").inputmask("99/99/9999",{ "placeholder": "mm/dd/yyyy", "alias": "mm/dd/yyyy", "oncomplete": function(){

        }});
    });
    



}; // end of module.exports





// WEBPACK FOOTER //
// ./js-source/blocks/mask.js